/* External */
import PropTypes from 'prop-types';

/* Ott */
import { CarouselType } from '@dtvgo/backend-service/normalize';

/* Components */
import CatalogAll from '../../../components/CatalogAll';

/* Hooks */
import useCarouselContents from '../../../hooks/useCarouselContents';
import useFetchCarousel from '../../../hooks/useFetchCarousel';

function CatalogVodLander({
  className,
  cardsPerRow,
  style,
  onCardArrowPress,
  focusFirstCard,
  hideMetadata,
  dark,
  onScrolledChange,
  sourceCarouselId,
  source,
  catalogTitle,
}) {
  const { carousel } = useFetchCarousel({
    sourceCarouselId,
    source,
    type: CarouselType.PORTRAIT,
  });

  const items = useCarouselContents(carousel);

  return (
    <CatalogAll
      className={className}
      cardsPerRow={cardsPerRow}
      style={style}
      onCardArrowPress={onCardArrowPress}
      focusFirstCard={focusFirstCard}
      hideMetadata={hideMetadata}
      dark={dark}
      onScrolledChange={onScrolledChange}
      items={items}
      type={CarouselType.PORTRAIT}
      catalogTitle={catalogTitle}
    />
  );
}

CatalogVodLander.propTypes = {
  className: PropTypes.string,
  focusFirstCard: PropTypes.bool,
  hideMetadata: PropTypes.bool,
  dark: PropTypes.bool,
  style: PropTypes.shape({}),
  cardsPerRow: PropTypes.number.isRequired,
  onCardArrowPress: PropTypes.func,
  onScrolledChange: PropTypes.func,
  sourceCarouselId: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired,
  catalogTitle: PropTypes.string,
};

CatalogVodLander.defaultProps = {
  className: '',
  style: undefined,
  focusFirstCard: false,
  hideMetadata: false,
  dark: false,
  onCardArrowPress: undefined,
  onScrolledChange: undefined,
  catalogTitle: '',
};

export default (CatalogVodLander);
